import React, { createContext, useContext, useState, useMemo } from "react";
import { Spin } from "antd";
import "./index.css";

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [tip, setTip] = useState("加载中...");

    const showLoading = (text = "加载中...") => {
        setTip(text);
        setLoading(true);
    };

    const hideLoading = () => {
        setLoading(false);
    };

    const value = useMemo(
        () => ({
            showLoading,
            hideLoading,
        }),
        []
    );

    return (
        <LoadingContext.Provider value={value}>
            {children}
            <Spin size={"large"} spinning={loading} fullscreen tip={tip} />
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoading must be used within a LoadingProvider");
    }
    return context;
};
